import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "../../styles/ContactForm.css";

const ContactForm = () => {
  const formRef = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_fx9sx27",  // from EmailJS
        "template_to6ofzs", // from EmailJS
        formRef.current,
        "qknIgeFGyLFGnHAS5"  // from EmailJS
      )
      .then(
        (result) => {
          alert("✅ Message sent successfully!");
          formRef.current.reset();
        },
        (error) => {
          alert("❌ Failed to send message. Try again.");
          console.error(error.text);
        }
      );
  };

  return (
    <section className="contact-form-section">
      <div className="contact-form-container">
        <div className="contact-form-header">
          <h2>Contact Us</h2>
          <p>Request a callback for our services.</p>
        </div>
        
        <form ref={formRef} onSubmit={sendEmail} className="contact-form-form">
          <div className="contact-form-group">
            <label htmlFor="name">
              <span className="contact-form-icon contact-form-user-icon"></span>
              Full Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="e.g., John Doe"
              required
            />
          </div>
          
          <div className="contact-form-group">
            <label htmlFor="phone">
              <span className="contact-form-icon contact-form-phone-icon"></span>
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              id="phone"
              placeholder="e.g., +91 98765 43210"
              required
            />
          </div>
          
          <div className="contact-form-group">
            <label htmlFor="service">
              <span className="contact-form-icon contact-form-service-icon"></span>
              Service of Interest
            </label>
            <select name="service" id="service" required>
              <option value="">Select a Service</option>
              <option value="basic-supportive-care">
                Basic Supportive Care
              </option>
              <option value="advanced-nursing">
                Advanced Nursing Care (Catheterization,Ryles tube,IV injections)
              </option>
              <option value="dementia-care">Dementia Care</option>
              <option value="pre-post-op">Pre & Post-Operative Care</option>
              <option value="wound-dressing">Wound Dressing</option>
              <option value="physiotherapy">Physiotherapy</option>
            </select>
          </div>
          
          <div className="contact-form-group">
            <label htmlFor="comments">
              <span className="contact-form-icon contact-form-comments-icon"></span>
              Comments
            </label>
            <textarea
              name="comments"
              id="comments"
              rows="4"
              placeholder="Tell us more about your needs..."
            />
          </div>
          
          <button type="submit" className="contact-form-submit-button">
            Submit Request
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;